import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { Observable, fromEvent } from 'rxjs';
import { Touchterminalpayment } from 'src/app/services/api/touchterminalpayment/touchterminalpayment.service';
@Component({
  selector: 'app-user-touch-terminal',
  templateUrl: './user-touch-terminal.component.html',
  styleUrls: ['./user-touch-terminal.component.css']
})
export class UserTouchTerminalComponent implements OnInit {
  eventHeight: Observable<any> = fromEvent(window, "resize");
  innerHeight: number = window.innerHeight;
  passForm: FormGroup | any;
  $error: any = false;
  searchbornedevice: any = false;
  currPos: any = this.tools.getStor("point_of_sale");
  admin: any;
  devices: any;
  currdevice: any;
  currdevicePrintAuto: any = true;
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialogRef: MatDialogRef<UserTouchTerminalComponent>,
    private formBuilder: FormBuilder,
    private tools: ToolsService,
    private Touchterminalpayment: Touchterminalpayment
  ) {
    this.searchbornedevice = data && data.borne ? true : false;

  }

  ngOnInit(): void {
    this.onWindowResize();
    this.createForm();

  }

  createForm() {
    this.passForm = this.formBuilder.group({
      user: ['', [Validators.required, Validators.minLength(4), Validators.pattern('^[0-9]+$')]],
    });
  }

  submitPass(formDirective: FormGroupDirective) {

    if (!this.passForm.valid) {
      this.$error = true;
      return;
    }
    this.$error = false;


    let data = {
      id_webshop: this.currPos.id_webshop,
      code: this.passForm.value.user
    }


    this.Touchterminalpayment.getAccesTouchTerminal(data, this.searchbornedevice).then(access => {


      if (access.code < 0 || !access.admin) {
        this.$error = true;
        return;
      }


      this.admin = access.admin;


      if (this.searchbornedevice) {
        this.currdevice = this.tools.getStor("devicePaybridge") ? this.tools.getStor("devicePaybridge") : null;
        this.currdevicePrintAuto =  this.currdevice  ? this.tools.getStor("devicePaybridgePrint") : true;
  
        this.devices = access.devices;

      }

      else {
        this.closeDial("ok");
      }



    }).catch(err => {
      console.error('err', err)

    })



  }


  /**
     * @description WindowResize
     */


  onWindowResize() {
    this.eventHeight.subscribe(event => {
      this.innerHeight = event.currentTarget.innerHeight;

    });
  }


  closeDial(data?: any) {

    this.dialogRef.close(data);
  }

  onfocus() {
    this.$error = false;
  }


  setdevice($event?: any) {


    this.currdevice ? this.tools.setStor("devicePaybridge", this.currdevice) : this.tools.removeStor("devicePaybridge");
    this.currdevice  ?this.tools.setStor("devicePaybridgePrint", this.currdevicePrintAuto) : this.tools.removeStor("devicePaybridgePrint");
    this.closeDial(this.currdevice ? "currdevice" : "null");
  }


}
